<template>
  <div class="reports">
    <div v-if="$store.state.pageLoaded" class="reports-listing">
      <div class="filter-wrapper">
        <!--<md-datepicker v-model="period.from" md-immediately>
          <label>Od</label>
        </md-datepicker>
        <md-datepicker v-model="period.to" md-immediately>
          <label>Do</label>
        </md-datepicker>-->
        <Autocomplete v-model="performanceID" :additionalField="'performance_date'" :stateObject="'performancesSimple'" :searchBy="'play_title'" :returnField="'id'" :label="'Odaberi izvedbu'"/>
        <md-button class="md-raised md-dense md-primary" v-on:click="getByDate">
          Traži
        </md-button>
      </div>
      <div v-if="$store.state.receivedData.reportsAboutPlay.list.hasOwnProperty('seat_count')" ref="reports">
        <h2 class="md-title">
          Izvještaj o skeniranim
          <span class="lighter" v-if="searched">
            {{ performance.play_title }} - {{ performance.performance_date }} - {{ performance.performance_time }}
          </span>
        </h2>
        <md-table class="print-table small-table">
          <md-table-row v-for="value, key in seatCount" v-if="key !== 'soldSeat' && key !== 'scannedSeat'">
            <md-table-cell>{{ value }}</md-table-cell>
            <md-table-cell>
              <span v-if="key == 'subscription_amount'">{{ formatCurrency($store.state.receivedData.reportsAboutPlay.list.seat_count[key]) }}</span>
              <span v-else>{{ $store.state.receivedData.reportsAboutPlay.list.seat_count[key] }}</span>
            </md-table-cell>
          </md-table-row>
          <md-table-row>
            <md-table-cell><b>Prodanih sjedala</b></md-table-cell>
            <md-table-cell></md-table-cell>
          </md-table-row>
          <md-table-row v-for="value, key in seatCount.soldSeat">
            <md-table-cell>{{ value }}</md-table-cell>
            <md-table-cell>
              {{ $store.state.receivedData.reportsAboutPlay.list.seat_count.sold_seat[key] }}
            </md-table-cell>
          </md-table-row>
          <md-table-row>
            <md-table-cell><b>Skenirana sjedala</b></md-table-cell>
            <md-table-cell></md-table-cell>
          </md-table-row>
          <md-table-row v-for="value, key in seatCount.scannedSeat">
            <md-table-cell>{{ value }}</md-table-cell>
            <md-table-cell>
              {{ $store.state.receivedData.reportsAboutPlay.list.seat_count.scanned_seat[key] }}
            </md-table-cell>
          </md-table-row>
          
          

        <md-button class="md-primary md-dense md-raised fixed-print-btn print-btn" v-on:click="print($refs.reports)">
          Ispiši
        </md-button>
      </div>
      <div v-else class="error">
        <h3>Nažalost nema izvješća za prikaz</h3>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ReportsMixin from '../../../mixins/reports-mixin';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'ReportsPlay',
  mixins: [FormatCurrency, ReportsMixin('getReportsCashRegister')],
  data(){
    return{
      performanceID: '',
      performance: '',
      period:{
        to: new Date(),
        from: new Date(),
      },
      seatCount:{
        'for_sale':'Ukupno u prodaji',
        'sold': 'Prodano',
        'soldSeat': {
          'gratis': 'Na blagajni - gratis',
          'offline': 'Na blagajni - naplatno',
          'online': 'Na webu',
        },
        'scannedSeat': {
          'gratis': 'Na blagajni - gratis',
          'offline': 'Na blagajni - naplatno',
          'online': 'Na webu',
        },
        'scanned': 'Skenirano',
        'double_scanned': 'Duplo skenirano',
      }
    }
  },

  computed:{
    ...mapGetters([
      'isPageLoaded'
    ])
  },

  methods:{
    zeroed(data){
      if(parseInt(data) < 10) return `0${data}`
      return data;
    },

    getByDate(){
      let context = {};
      if(this.period.from !== null && this.period.to !== null && this.period.from <= this.period.to){
        this.title = `za razdoblje od ${this.period.from.toLocaleDateString('hr-HR')}
        do ${this.period.to.toLocaleDateString('hr-HR')}`

        context['to'] = this.period.to.toLocaleDateString('hr-HR');
        context['from'] = this.period.from.toLocaleDateString('hr-HR');
      }

      if(this.performanceID !== ''){
        context['performance'] = this.performanceID;
      }

      this.$store.dispatch('getReportsAboutPlay', context);

      this.searched = true;
    },

    getPlayDate(data){
      let date = new Date(data);
      return{
        date: `${this.zeroed(date.getDate())}.${this.zeroed(date.getMonth()+1)}.${this.zeroed(date.getFullYear())}`,
        time: `${this.zeroed(date.getHours())}:${this.zeroed(date.getMinutes())}`,
      }
    }
  },

  watch:{
    isPageLoaded(value){
      if(value) this.performanceID = this.$store.state.receivedData.performancesSimple.list[0].id;
    },

    performanceID(){
      this.performance = this.$store.state.receivedData.performancesSimple.list.filter((performance) =>{return performance.id == this.performanceID})[0];
    }
  }
}
</script>

<style lang="scss" scoped>
  .reports h2{
    text-align: center;
    margin: 50px 0;
    span{
      display: block;
    }

    .lighter{
      margin-top: 15px;
      font-size: 16px;
    }
  }

  .reports-listing{
    padding-bottom: 80px;
    .md-table{
      & + .md-table{
        margin-top: 50px;
      }
    }
  }

  .filter-wrapper{
    display: flex;
    position: relative;
    max-width: 900px;

    .md-field{
      margin-right: 20px;
    }
  }

  .error{
    font-size: 22px;
    margin: 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/ReportsAboutScan.vue